import { environment } from 'src/environments/environment';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class RedirectService {
  public redirectToCanonicalUrl(): string {
    // Preserve full URL path and query parameters when redirecting from m-3.com to gerances.ch
    const currentUrl = new URL(window.location.href);
    const canonicalUrl = new URL(environment.redirectUri);
    canonicalUrl.pathname = currentUrl.pathname;
    canonicalUrl.search = currentUrl.search;
    canonicalUrl.hash = currentUrl.hash;
    return canonicalUrl.toString();
  }
}
